<template>
  <div class="range">
    <div class="range__title">{{ $t("FL10") }}</div>
    <div v-if="!samePrice" class="range__body">
      <div class="range__slider range__slider--real">
        <div ref="slider"></div>
      </div>
      <label class="hidden" for="from">from price</label>
      <label class="hidden" for="to">to price</label>
      <label class="hidden" for="fake_from">from price</label>
      <label class="hidden" for="fake_to">to price</label>
      <div class="range__inputs">
        <input
          id="from"
          :value="getPrice.from"
          @change="handleFromChange"
          @keydown="handleKeydown"
          type="number"
          class="range__input"
        />
        <input
          id="to"
          :value="getPrice.to"
          @change="handleToChange"
          @keydown="handleKeydown"
          type="number"
          class="range__input"
        />
      </div>
    </div>
    <div v-if="samePrice" class="range__body">
      <div class="range__slider range__slider--fake">
        <div class="fake__track"></div>
        <div class="fake__track fake__track--active"></div>
        <div class="fake__handle fake__handle--left"></div>
        <div class="fake__handle fake__handle--right"></div>
      </div>
      <div class="range__inputs">
        <input
          id="fake_from"
          :value="getPrice.from"
          disabled
          type="number"
          class="range__input"
        />
        <input
          id="fake_to"
          :value="getPrice.to"
          disabled
          type="number"
          class="range__input"
        />
      </div>
    </div>
  </div>
</template>
<script>
import noUiSlider from "nouislider";
import { mapGetters } from "vuex";

export default {
  name: "RangePrice",
  computed: {
    ...mapGetters("products", ["getPrice"])
  },
  data() {
    return {
      samePrice: true
    };
  },
  mounted() {
    this.renderSlider();
  },
  destroyed() {
    this.$store.dispatch("products/deletePrice");
  },
  methods: {
    handleKeydown(e) {
      if (["Period", "Comma"].includes(e.code)) {
        if (!e.target.value || e.target.value.match(/[,.]/)) {
          e.preventDefault();
        }
        return;
      }
      if (
        ![
          "Digit1",
          "Digit2",
          "Digit3",
          "Digit4",
          "Digit5",
          "Digit6",
          "Digit7",
          "Digit8",
          "Digit9",
          "Digit0",
          "Enter",
          "Backspace",
          "Delete",
          "ArrowUp",
          "ArrowDown",
          "ArrowLeft",
          "ArrowRight"
        ].includes(e.code)
      ) {
        e.preventDefault();
      }
    },
    handleFromChange(e) {
      const from = e.target.valueAsNumber || this.getPrice.from;
      this.$store.dispatch("products/setFromToPrice", [from, this.getPrice.to]);
    },
    handleToChange(e) {
      const to = e.target.valueAsNumber || this.getPrice.to;
      this.$store.dispatch("products/setFromToPrice", [this.getPrice.from, to]);
    },
    renderSlider() {
      if (!this.$refs.slider) {
        return;
      }
      const min = this.getPrice.min;
      const max = this.getPrice.max;
      const perc30 =
        (max - min) / 10 > 2500 ? min + 2500 : min + (max - min) / 10;
      const perc70 =
        (max - min) * 0.6 > 25000 ? min + 25000 : min + (max - min) * 0.6;
      noUiSlider.create(this.$refs.slider, {
        start: [this.getPrice.from, this.getPrice.to],
        connect: true,
        range: {
          min,
          "30%": perc30,
          "70%": perc70,
          max
        },
        cssPrefix: "slider__"
      });
      const self = this;
      this.$refs.slider.noUiSlider.on("update", function(values, handle) {
        if (
          self.getPrice.from !== values.from ||
          self.getPrice.to !== values.to
        ) {
          self.$store.dispatch("products/setFromToPrice", values);
        }
      });
    }
  },
  watch: {
    async getPrice(n, o) {
      {
        if (n.min === n.max) {
          this.samePrice = true;
          await this.$forceUpdate();
          return;
        }
        if (
          n.min !== o.min ||
          n.max !== o.max ||
          n.from !== o.from ||
          n.to !== o.to
        ) {
          this.samePrice = false;
          await this.$forceUpdate();
          if (this.$refs.slider && this.$refs.slider.noUiSlider) {
            this.$refs.slider.noUiSlider.destroy();
          }
          this.renderSlider();
        }
      }
    }
  }
};
</script>
<style lang="scss">
.range {
  &__title {
    color: #060606;
    font-family: "Lato", sans-serif;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 4px;
  }
  &__body {
    position: relative;
    display: flex;
  }
  &__slider {
    width: 172px;
    margin-right: 22px;
  }
  &__inputs {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 172px;
    left: 1px;
  }
  &__input {
    width: 82px;
    height: 30px;
    color: #666666;
    font-family: "Lato", sans-serif;
    font-size: 14px;
    text-align: left;
    padding-left: 12px;
    padding-top: 8px;
    padding-bottom: 10px;
    box-shadow: none;
    font-weight: 400;
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    &[type="number"] {
      -moz-appearance: textfield;
    }
    &:disabled {
      opacity: 1;
      color: #666666;
    }
  }
}

.slider {
  position: relative;
  &__base {
    position: relative;
    width: 172px;
    height: 3px;
    background-color: #e9e9e9;
    box-sizing: border-box;
    top: 13px;
    left: 3px;
    cursor: pointer;
  }
  &__connects {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;
  }
  &__connect {
    background-color: #a42a7b;
    height: 100%;
    width: 100%;
    will-change: transform;
    position: absolute;
    z-index: 1;
    top: 0;
    right: 0;
    transform-origin: 0 0;
    transform-style: flat;
  }
  &__origin {
    position: absolute;
    z-index: 5;
    height: 0;
    width: 10%;
    top: 0;
    right: 0;
    box-sizing: border-box;
    user-select: none;
    touch-action: none;
  }
  &__handle {
    position: relative;
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: #a42a7b;
    top: -5px;
    left: 10px;
    outline: none;
    cursor: pointer;
    &:hover {
      background-color: #f2b235;
    }
    &-lower {
    }
    &-upper {
    }
  }
}

.fake {
  &__range {
    display: block;
    width: 173px;
  }
  &__track {
    width: 172px;
    height: 3px;
    display: block;
    position: absolute;
    background-color: #f5f5f5;
    top: 50%;
    transform: translateY(-50%);
    &--active {
      background-color: #a42a7b;
      left: 0;
    }
  }
  &__handle {
    width: 12px;
    height: 12px;
    position: absolute;
    display: block;
    top: 50%;
    transform: translateY(-50%);
    background-color: #a42a7b;
    border-radius: 50%;
    &--right {
      left: 172px;
    }
  }
}

.hidden {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  opacity: 0;
  margin: 0;
  padding: 0;
}
</style>
